import React, { useState, useRef, useEffect } from "react";

const RenameModal = ({ initialName, onCancel, onSave }) => {
  const [newName, setNewName] = useState(initialName);
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      // Find the last dot in the filename
      const dotIndex = newName.lastIndexOf(".");
      // If a dot is found (and it's not at the start), select up to that point; otherwise select full name.
      const selectionEnd = dotIndex > 0 ? dotIndex : newName.length;
      inputRef.current.focus();
      inputRef.current.setSelectionRange(0, selectionEnd);
    }
    // We disable exhaustive-deps because we only want this to run once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = () => {
    onSave(newName);
  };
  
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };
  
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded shadow-lg w-96">
        <h2 className="text-xl dark:text-gray-200 font-bold mb-4">Rename File/Folder</h2>
        <input
          ref={inputRef}
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={handleKeyDown}
          className="w-full p-2 border border-gray-300 rounded mb-4"
        />
        <div className="flex justify-end space-x-4">
          <button onClick={onCancel} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">
            Cancel
          </button>
          <button onClick={handleSave} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameModal;